import {main_phaser} from "./MadnesApp";
import {forcestop_enable, fps, he, madnes_objects, set_forcestop_enable, wi} from "./madnes_variables";
import {
    madnes_add_img,
    madnes_add_sprite,
    madnes_key_exist, madnes_remove_sprite,
    madnes_set_alpha, madnes_set_img_center, madnes_set_pos,
    madnes_set_scale,
    madnes_set_visible
} from "./madnes_object";
import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "./madnes_audio";
import {
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_coin_move_to,
    madnes_rem_from_render,
    madnes_scale_to
} from "./madnes_render";
import {madnes_eval, madnes_fill_range} from "./madnes";
import {madnes_add_bitmap_text, madnes_set_bitmaptext_float, madnes_set_text} from "./madnes_text";
import {madnes_adapter, wallet} from "./madnes_variables";

export function madnes_anim_add(name, animname, range)
{
    madnes_objects[name].animations.add(animname, range);
}

export function madnes_anim_oncomplete_once(name, animname, func) {
    madnes_objects[name].animations._anims[animname].onComplete.addOnce(func, this);
}

/**
 * @param {string} name
 * @param {string} animname
 * @param {number=} speed
 */
export function madnes_anim_play(name, animname, speed)
{
    if(typeof speed == "undefined")
    {
        speed = fps;
    }
    madnes_objects[name].animations.play(animname, speed, false, false);
}

export function madnes_anim_play_async(name, animname, delay = 0, speed = fps) {
    return new Promise(res => {

        setTimeout(() => {
            madnes_objects[name].animations._anims[animname].onComplete.addOnce(res, this);
            madnes_objects[name].animations.play(animname, speed, false, false);
        }, delay);
    });
}

/**
 * @param {string} name
 * @param {string} animname
 * @param {number=} speed
 */
export function madnes_anim_loop(name, animname, speed)
{
    if(typeof speed == "undefined")
    {
        speed = fps;
    }
    madnes_objects[name].animations.play(animname, speed, true, false);
}

export function madnes_anim_stop(name)
{
    madnes_objects[name].animations.stop();
}

export function madnes_anim_is_playing(name)
{
    /*if(!madnes_objects[name].visible)
    {
        return false;
    }*/

    if(
        madnes_objects[name].animations != null &&
        madnes_objects[name].animations.currentAnim != null
    )
    {
        return madnes_objects[name].animations.currentAnim.isPlaying;
    }

    return false;
}

export function madnes_anims_exists(name, animname)
{
    return animname in madnes_objects[name]["animations"]["_anims"];
}

export function madnes_anims_remove(name)
{
    madnes_objects[name].animations.destroy();
}

export function madnes_generate_frame_names(prefix, start, stop, suffix, zeroPad)
{
    return Phaser.Animation.generateFrameNames(prefix, start, stop, suffix, zeroPad);
}

export function madnes_anim_add_oncomplete(name, func)
{
    madnes_objects[name].animations.currentAnim.onComplete.add(func, this);
}

export function madnes_anim_add_oncomplete_once(name, func)
{
    madnes_objects[name].animations.currentAnim.onComplete.addOnce(func, this);
}


// COIN_VALUE start
var coin_manager = null;
var coin_emitter = null;
var madnes_coin_enabled = 0;

export function madnes_start_coin()
{
    madnes_audio_loop("coins_loop");
    madnes_coin_enabled = 1;
    madnes_control_coin(0);
}

export function madnes_stop_coin()
{
    setTimeout(madnes_audio_stop.bind(this, "coins_loop"), 2600);
    madnes_coin_enabled = 0;
}

var madnes_control_coin_buffer = new Array();
for(var i = 0; i < 2 * 8; i++)
{
    madnes_control_coin_buffer[i] = new Array();
}

var madnes_control_coin_buffer_length_max = 10;

var madnes_coins_shift = 0;
export function set_madnes_coins_shift(val) {
    madnes_coins_shift = val;
}


function madnes_control_coin(pos)
{
    if(madnes_control_coin_buffer[pos].length == 0)
    {
        if(madnes_control_coin_buffer_length_max > 10)
        {
            if(main_phaser.time.fps < 40)
            {
                madnes_control_coin_buffer_length_max--;
            }
        }
        if(madnes_control_coin_buffer_length_max > 1)
        {
            if(main_phaser.time.fps < 20)
            {
                madnes_control_coin_buffer_length_max--;
            }
        }
        if(madnes_control_coin_buffer_length_max < 30)
        {
            if(main_phaser.time.fps > 56)
            {
                madnes_control_coin_buffer_length_max++;
            }
        }

        if(madnes_coin_enabled)
        {
            var next = pos + 1;
            if(next > madnes_control_coin_buffer.length - 1)
            {
                next = 0;
            }

            setTimeout(madnes_control_coin.bind(this, next), 500);
        }
    }

    if(madnes_control_coin_buffer[pos].length < madnes_control_coin_buffer_length_max)
    {

        var tmp_x = (wi + madnes_coins_shift) / 2;

        if(pos % 2 == 0)
        {
            tmp_x = tmp_x * 1 - 60;
        }
        else
        {
            tmp_x = tmp_x * 1 + 60;
        }

        madnes_add_sprite("coin_sprite_" + pos + "_" + madnes_control_coin_buffer[pos].length, "coin_sprite", tmp_x, he * 1.01 + ( he * 0.2 * Math.random() ) , 1, 0.5, 0.5);

        madnes_set_scale("coin_sprite_" + pos + "_" + madnes_control_coin_buffer[pos].length, 0.70, 0.70);
        madnes_anim_add("coin_sprite_" + pos + "_" + madnes_control_coin_buffer[pos].length, "anim", madnes_fill_range(0, 45));
        madnes_anim_loop("coin_sprite_" + pos + "_" + madnes_control_coin_buffer[pos].length, "anim");

        var endpos = ( (wi + madnes_coins_shift) / 2 ) * Math.random();

        if(pos % 2 == 0)
        {
            endpos = endpos * 1 - ( wi * 0.42 );
        }
        else
        {
            endpos = endpos + wi / 2;
            endpos = endpos * 1 + ( wi * 0.42 );
        }

        madnes_coin_move_to("coin_sprite_" + pos + "_" + madnes_control_coin_buffer[pos].length, endpos, he * 1.05, 2400, madnes_control_coin_rem.bind(this, pos, madnes_control_coin_buffer[pos].length));
        madnes_control_coin_buffer[pos][madnes_control_coin_buffer[pos].length] = 1;

        setTimeout(madnes_control_coin.bind(this, pos), ( 1000 / fps ) * ( 30 / madnes_control_coin_buffer_length_max ) );
    }

}

function madnes_control_coin_rem(side, coin)
{
    if(coin + 1 >= madnes_control_coin_buffer[side].length)
    {
        madnes_remove_coins_from_buffer(side);
    }
}

function madnes_remove_coins_from_buffer(side)
{
    for(var i in madnes_control_coin_buffer[side])
    {
        madnes_remove_sprite("coin_sprite_" + side + "_" + i);
    }
    madnes_control_coin_buffer[side] = new Array();
}

// COIN_VALUE end


export function madnes_add_show_money(x, y) {

    if(typeof madnes_adapter.to_load_fonts["win_font"] == 'undefined') {
        return;
    }

    madnes_add_img("moneyadd_text_bg", "win_font_bg", -9999, -9999, 1, 0.5, 0.5);
    madnes_set_visible("moneyadd_text_bg", false);
    madnes_add_bitmap_text("moneyadd_text", "win_font", -9999, -9999, "123456789", 80);
    madnes_set_visible("moneyadd_text", false);
    madnes_set_img_center("moneyadd_text", 0.5, 0.5);
    madnes_set_scale("moneyadd_text", x ? x : madnes_show_money_anim_scale_from, y ? y : madnes_show_money_anim_scale_from);
}

export function set_show_money_pos_x(val) {
    madnes_show_money_pos_x = val;
}

export function set_show_money_pos_y(val) {
    madnes_show_money_pos_y = val;
}

var madnes_show_money_max = 0;
var madnes_show_money_curr = 0;
var madnes_show_money_callback = null;
var madnes_show_money_pos_x;
var madnes_show_money_pos_y;
var forcestop_enable_tmp = forcestop_enable;

var madnes_show_money_with_decimals = false;
export function madnes_show_money(money, callback, withDecimals = false)
{
    madnes_show_money_with_decimals = withDecimals;

    forcestop_enable_tmp = forcestop_enable;
    set_forcestop_enable(false); //forcestop_enable = false;

    madnes_show_money_max = money;
    madnes_show_money_curr = 0;

    if(typeof callback == "undefined")
    {
        madnes_show_money_callback = null;
    }
    else
    {
        madnes_show_money_callback = callback;
    }

    var moneyadd_text_pos_x = typeof madnes_show_money_pos_x === 'undefined' ? wi / 2 : madnes_show_money_pos_x;
    var moneyadd_text_pos_y = typeof madnes_show_money_pos_y === 'undefined' ? he / 2 : madnes_show_money_pos_y;

    if(madnes_show_money_with_decimals) {
        let decimals = wallet.getDecimalPlaces();
        madnes_set_bitmaptext_float("moneyadd_text", 0, decimals);
    } else {
        madnes_set_text("moneyadd_text", "0");
    }

    madnes_set_pos("moneyadd_text", moneyadd_text_pos_x * 1, moneyadd_text_pos_y * 1);
    madnes_set_visible("moneyadd_text", true);
    madnes_set_pos("moneyadd_text_bg", moneyadd_text_pos_x * 1, moneyadd_text_pos_y * 1);
    madnes_set_visible("moneyadd_text_bg", true);

    madnes_set_alpha("moneyadd_text", 0);
    madnes_set_alpha("moneyadd_text_bg", 0.4);

    madnes_alpha_to("moneyadd_text",1,200);
    madnes_alpha_to("moneyadd_text_bg",1,200);

    setTimeout(function() {
        madnes_add_to_render(madnes_show_money_anim);
    }, 100);
}

var madnes_show_money_anim_pos = 0;
var madnes_show_money_anim_scale_from = 1;
var madnes_show_money_anim_scale_to = 1.1;
var madnes_show_money_anim_callback_timeout = 700;
function madnes_show_money_anim()
{
    if(
        madnes_show_money_anim_pos++ % 4 != 0
    )
    {
        return;
    }

    var add = 0;

    if(madnes_show_money_with_decimals) {
        add = ( Math.random() / 2 ) * madnes_show_money_max;

        if(add > madnes_show_money_max / 20)
        {
            add = madnes_show_money_max / 20;
        }

    } else {
        add = Math.round( ( Math.random() / 2 ) * madnes_show_money_max );

        if(add > madnes_show_money_max / 20)
        {
            add = Math.round( madnes_show_money_max / 20 );
        }
    }

    if(add <= 0) {
        add = 1;
    }

    madnes_show_money_curr = madnes_show_money_curr * 1 + add;
    if(madnes_show_money_curr >= madnes_show_money_max)
    {
        madnes_audio_play("remittance_B");
        madnes_scale_to("moneyadd_text", madnes_show_money_anim_scale_to, madnes_show_money_anim_scale_to, 40, function() {
            madnes_scale_to("moneyadd_text", madnes_show_money_anim_scale_from, madnes_show_money_anim_scale_from, 200);
        });

        madnes_show_money_curr = madnes_show_money_max;

        if(madnes_show_money_with_decimals) {
            let decimals = wallet.getDecimalPlaces();
            madnes_set_bitmaptext_float("moneyadd_text", madnes_show_money_curr, decimals);
        } else {
            madnes_set_text("moneyadd_text", madnes_show_money_curr.toString());
        }

        madnes_rem_from_render(madnes_show_money_anim);

        setTimeout(function() {
            madnes_alpha_to("moneyadd_text", 0, 200);
            madnes_alpha_to("moneyadd_text_bg", 0, 200);
        }, 600);

        setTimeout(function() {
            madnes_set_pos("moneyadd_text", -9999, -9999);
            madnes_set_visible("moneyadd_text", false);
            madnes_set_pos("moneyadd_text_bg", -9999, -9999);
            madnes_set_visible("moneyadd_text_bg", false);
        }, 800);

        if(madnes_show_money_callback != null)
        {
            setTimeout(function()
                {
                    set_forcestop_enable(forcestop_enable_tmp); ///forcestop_enable = forcestop_enable_tmp;
                    madnes_eval(madnes_show_money_callback);
                },
                madnes_show_money_anim_callback_timeout);
        }
    }
    else
    {
        madnes_audio_play("remittance_A");
        if(madnes_show_money_with_decimals) {
            let decimals = wallet.getDecimalPlaces();
            madnes_set_bitmaptext_float("moneyadd_text", madnes_show_money_curr, decimals);
        } else {
            madnes_set_text("moneyadd_text", madnes_show_money_curr.toString());
        }
    }
}